'use strict';

var vkBridge = require('@vkontakte/vk-bridge');
var vk_randomizeRequestId_index = require('../randomizeRequestId/index.js');
var locals_STATS_index = require('../../locals/STATS/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var vkBridge__default = /*#__PURE__*/_interopDefaultLegacy(vkBridge);

/**
 * Вызов метода АПИ
 * @return {Promise}
 */
const bridgeApiRequest = (
    method,
    params = {},
    accessToken = locals_STATS_index.VK_ACCESS_TOKEN,
    version = locals_STATS_index.VK_API_VERSION,
) => vkBridge__default['default']
    .send('VKWebAppCallAPIMethod', {
        method,
        request_id: vk_randomizeRequestId_index(),
        params: {
            ...params,
            access_token: accessToken,
            v: version,
        },
    })
    .then((success) => ({ result: 'success', data: success.response }))
    .catch((error) => ({ result: 'fail', error }));

module.exports = bridgeApiRequest;
